import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDSNhanVienGiaoViec, layDanhMucNhanVien } from '../../services/danhmuc';
import { NhanVienResponse } from '@app/models/nhanvien/NhanVien';
import { layLanhDaoPhuTrachPhongTheoDonVi } from '../../services/nhanvien';
import { arrayCommon } from '../../helpers/common';
import { useSelector } from 'react-redux';
import { maChucVu } from '../../constants';

const boChuDemo = (hoTen?: string) => (hoTen || "").replace(/demo/gi, "").replace(/\s+/g, " ").trim();

export const convertDataSelectBox = (data: any, giaoViec?: boolean) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: NhanVienResponse) => {
            const hoTen = boChuDemo(_item.hoTen);
            return {
                value: _item.id,
                label: giaoViec ? hoTen :  hoTen + " - " + _item.tenChucVu + " - " + _item.tenDonVi
            }
        });
    }
    return rs;
}
const NhanVienPhongBanSelectBox = ({ value, giaoViec, dsNguoiGiaoViec, disabled, multiple, allowClear, onChange, idDonVi, noLanhDao, idNhanVienAdd }: { value?: number | number[], giaoViec?: boolean, dsNguoiGiaoViec?: boolean, disabled?: boolean, multiple?: boolean, allowClear?: boolean, onChange: (e: any) => void, idDonVi?:number, noLanhDao?: boolean, idNhanVienAdd? : number }) => {

    const user = useSelector((state: any) => state.auth.currentUser);
    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            if (giaoViec) {
                if (dsNguoiGiaoViec) {
                    let rs = await layDanhMucNhanVien();
                    let nhanViens = rs.filter((item: any) => item.isLanhDaoPhong || item.maChucVu == maChucVu.phoGiamDoc);
                    nhanViens.push({ id: -1, hoTen: "Nhân sự tổng hợp" });
                    setData(convertDataSelectBox(nhanViens, true));
                } else {
                    let rs = await layDSNhanVienGiaoViec();
                    setData(convertDataSelectBox(rs, true));
                }
            } else {
                let rs = await layDanhMucNhanVien();
                let nhanViens = rs.filter((item: any) => item.idDonVi == idDonVi);
                if (idNhanVienAdd != null && idNhanVienAdd > 0) {
                    var isExists = arrayCommon.isExisted(nhanViens.map(x => x.id), idNhanVienAdd);
                    if (!isExists) {
                        let nhanVienToAdd = rs.find((item: any) => item.id == idNhanVienAdd);
                        if (nhanVienToAdd) {
                            nhanViens.push(nhanVienToAdd);
                        }
                    }
                }
                let lanhDao = await layLanhDaoPhuTrachPhongTheoDonVi(idDonVi)
                if (lanhDao.hoTen != null && !noLanhDao) {
                    setData(convertDataSelectBox([lanhDao, ...nhanViens]));
                }
                else {
                    setData(convertDataSelectBox(nhanViens));
                }
            }
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, [idNhanVienAdd]);
    return (
        multiple || giaoViec ?
            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn nhân sự--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                value={value}
                options={data}
                disabled={disabled}
                mode='multiple'
                allowClear={allowClear} notFoundContent="Không có dữ liệu"
                onChange={(e) => {
                    onChange({
                        target: {
                            value: e
                        }
                    })
                }}
            /> :
            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn nhân sự--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                value={value}
                options={data}
                disabled={disabled}
                allowClear={allowClear} notFoundContent="Không có dữ liệu"
                onChange={(e) => {
                    onChange({
                        target: {
                            value: e
                        }
                    })
                }}
            />
    );
};

export default NhanVienPhongBanSelectBox;
